export default {
  deviceOverview: 'Device Overview',
  historicalData: 'Historical Data',
  curveAnalysis: 'Curve Analysis',
  statisticalAnalysis: 'Statistical Data',
  faultStatistics: 'Alarm Statistics',
  unconventionalData: 'Unconventional Data',
  realTime: 'Real Time Data',
  timing: 'Timing',
  log: 'Log',
  indicatingData: 'indicator Data',
  energyConservation: 'Ionserve Energy and Reduce Emissions',
  deviceConfig: 'Device Configuration',
  operatingCurve: '24-Hour Operating Curve',
  runTime: 'Run time',
  accumulatedTraffic: 'Daily cumulative traffic',
  powerGeneration: 'Daily cumulative power generation',
  carbonEmission: 'Carbon emission',
  failureType: 'Alarm type proportion',
  alarmStatistics: 'Alarm statistics in the past 15 days',
  numberAlarms: 'Number of alarms',
  faultRanking: 'Fault Ranking',
  statisticalAnalysis1: 'statistical analysis',
  working: 'Working',
  reversal: 'Reversal',
  stop: 'Shutdown',
  faultReset: 'Fault reset',
  updateTime: 'Update time',
}
